// extracted by mini-css-extract-plugin
export default {"root":"TextWithMention_root__mE+nr","clickable":"TextWithMention_clickable__9ZvQu","disabled":"TextWithMention_disabled__s8+SU"};